import React from "react";
import { motion } from "framer-motion";
import HeroBgAnimation from "../HeroBgAnimation";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ResumeButton,
  TypewriterWrapper,
} from "./HeroStyle";
import HeroImg from "../../images/HeroImage.png";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import { slideFromLeft, slideFromRight } from "../../App";
import TechOrbit from "./TechOrbit";

const HeroSection = () => {
  return (
    <div id="about">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <motion.div
            variants={slideFromLeft}
            initial="hidden"
            animate="visible"
            style={{ width: '100%' }}
          >
            <HeroLeftContainer id="Left">
              <Title>
                Hi, I am <br /> {Bio.name}
              </Title>
              <TextLoop>
                I am a
                <TypewriterWrapper>
                  <Span>
                    <Typewriter
                      options={{
                        strings: Bio.roles,
                        autoStart: true,
                        loop: true,
                        delay: 50,
                        deleteSpeed: 30,
                        cursor: '|',
                      }}
                    />
                  </Span>
                </TypewriterWrapper>
              </TextLoop>
              <SubTitle>{Bio.description}</SubTitle>
              <ResumeButton href={Bio.resume} target="display">
                Check Resume
              </ResumeButton>
            </HeroLeftContainer>
          </motion.div>

          <motion.div
            variants={slideFromRight}
            initial="hidden"
            animate="visible"
            style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
          >
            <HeroRightContainer id="Right">
              <TechOrbit profileImage={HeroImg} />
            </HeroRightContainer>
          </motion.div>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
